import { Inject, Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, AppConfig } from './config-initialization.service';

export const apiURLs = {
  languages: '/languages/'
};
@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig,
    ) { }
  
  getTranslation(lang: string): Observable<any> {
    return Observable.create(observer => {
      return this.http.get(this.config.restApiUrl + apiURLs.languages + lang).subscribe(res => {
        if(res['message'] == 'Maintenance'){ // api is in maintenance mode, switch to local     
          this.http.get('./assets/i18n/' + lang + '.json').subscribe(res => {      
            observer.next(res);      
            observer.complete();     
          });    
        }    
        else{     
          //console.log('translations fetched:', res['translations']);     
          observer.next(res['translations']);     
          observer.complete();    
        }    
      },    
      error => {     
        // failed to retrieve from api, switch to local     
        this.http.get('./assets/i18n/' + lang + '.json').subscribe(res => {      
          observer.next(res);      
          observer.complete();     
        });    
      }   
      );  
    }); 
  }}
